export class TilesInitializer {
	/**
	 * Initializes the Slider.
	 *
	 * @returns void
	 */
	init() {
		const flippableTiles = document.querySelectorAll('.tiles-module-container.back-enabled');
		// Loop through each tile and add a click event listener
		flippableTiles.forEach(function (tile) {
			tile.addEventListener('click', function () {
				// Toggle the .is-flipped class on the clicked tile
				this.classList.toggle('is-flipped');
			});
		});
	}
}
